import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SecteurActivite, SecteurActivitePayload } from '../models/secteur-activite';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SecteurActiviteService {

  private apiUrl = `${environment.baseUrlApi}/secteur-activite`;

  constructor(private http: HttpClient) {}

  /**
   * GET /api/secteur-activite/all
   */
  getAll(): Observable<SecteurActivite[]> {
    return this.http.get<SecteurActivite[]>(`${this.apiUrl}/all`);
  }

  /**
   * GET /api/secteur-activite/{id}
   */
  getById(id: number): Observable<SecteurActivite> {
    return this.http.get<SecteurActivite>(`${this.apiUrl}/${id}`);
  }

  /**
   * POST /api/secteur-activite/add
   */
  create(payload: SecteurActivitePayload): Observable<SecteurActivite> {
    return this.http.post<SecteurActivite>(`${this.apiUrl}/add`, payload);
  }

  /**
   * PUT /api/secteur-activite/update/{id}
   */
  update(id: number, payload: SecteurActivitePayload): Observable<SecteurActivite> {
    return this.http.put<SecteurActivite>(`${this.apiUrl}/update/${id}`, payload);
  }

  /**
   * DELETE /api/secteur-activite/delete/{id}
   */
  delete(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/delete/${id}`);
  }
}